import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";

import { GetBankOnlineGatewaysForIncreaseCreditDto } from "src/app/core/api/models";
import { BankOnlineGatewaysService } from "src/app/core/api/services";
import { TypeIpGsDisplay } from "src/app/core/enums/display/Type-IpGs.display";
import { ConsoleService } from "src/app/core/services/console.service";
import { AppDomService } from "src/app/core/services/dom.service";
import { PaymentGatewaySelectorType } from "src/app/core/types/payment-gateway-selector.type";
import { TypeIpGs } from "../../../core/api/models/type-ip-gs";

@Component({
    selector: "payment-gateway-selector",
    templateUrl: "./payment-gateway-selector.component.html",
    styleUrls: ["./payment-gateway-selector.component.scss"],
    standalone: false
})
export class PaymentGatewaySelectorComponent implements OnInit {
  //#properties

  items: GetBankOnlineGatewaysForIncreaseCreditDto[];

  @Input("tagName") tagName: string;
  @Input("type") type: PaymentGatewaySelectorType = "default";
  @Input("imageSize") imageSize: number = 64;
  @Input("itemSize") itemSize: number = 80;

  @Output("selectedItem") selectedItem =
    new EventEmitter<GetBankOnlineGatewaysForIncreaseCreditDto>();
  @Output("itemsCount") itemsCount = new EventEmitter<number>();
  @Output("isShowPaymentGatewaySelector") isShowPaymentGatewaySelector =
    new EventEmitter<boolean>(true);

  loading: boolean;
  get TypeIpGs() {
    return TypeIpGs;
  }
  public TypeIpGsDisplay: typeof TypeIpGsDisplay = TypeIpGsDisplay;
  1;
  iconsPath: string = "assets/media/banks/64/";
  currentTagName: string;
  subscription: Subscription;
  //#endregion

  constructor(
    protected currentService: BankOnlineGatewaysService,
    private elementRef: ElementRef
  ) {
    this.currentTagName = elementRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit() {
    try {
      if (!this.tagName?.trim()) this.tagName = this.currentTagName;
      //call api and get BankOnlineGateways
      this.getBankOnlineGatewaysApi();
    } catch (error) {
      ConsoleService.error("error", error);
    }
  }

  getBankOnlineGatewaysApi() {
    this.loading = true;

    if (this.type == "default")
      this.subscription = this.currentService
        .bankOnlineGatewaysGetBankOnlineGateways({
          body: { pageSize: 1000, pageNumber: 1 },
        })
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((items) => {
          this.getItems(items?.data);
        });

    if (this.type == "forIncreaseCredit")
      this.subscription = this.currentService
        .bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit({
          body: { pageSize: 1000, pageNumber: 1 },
        })
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((items) => {
          this.getItems(items?.data);
        });
  }

  getItems(items: GetBankOnlineGatewaysForIncreaseCreditDto[]) {
    this.items = items;
    this.itemsCount.emit(items.length);
    if (this.items?.length == 0) this.isShowPaymentGatewaySelector.emit(false);

    this.selectFirstItem();
  }

  async selectFirstItem() {
    const itemsElements = await AppDomService.getElementsByQueryAsync(
      `${this.tagName} [data-gateway-id]`
    );

    if (itemsElements?.length && this.items?.length)
      this.onSelect(this.items[0]);
  }

  onSelect(bankOnlineGateway: GetBankOnlineGatewaysForIncreaseCreditDto) {
    document
      .querySelectorAll(`${this.tagName} [data-gateway-id]`)
      .forEach((element: Element) => {
        element.classList.remove("active");
        const attrValue = element.getAttribute("data-gateway-id");
        if (+attrValue === bankOnlineGateway.id)
          element.classList.add("active");
      });

    this.emit(bankOnlineGateway);
  }

  getIconSrc(type: TypeIpGs): string {
    let path;

    switch (type) {
      case TypeIpGs.AsanPardakht:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.AsanPardakht]}.png`;
        break;
      case TypeIpGs.Mellat:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.Mellat]}.png`;
        break;
      case TypeIpGs.Saman:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.Saman]}.png`;
        break;
      case TypeIpGs.Sepehr:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.Sepehr]}.png`;
        break;
      case TypeIpGs.ParbadVirtual:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.ParbadVirtual]}.png`;
        break;
      case TypeIpGs.IdPay:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.IdPay]}.png`;
        break;
      case TypeIpGs.IranKish:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.IranKish]}.png`;
        break;
      case TypeIpGs.Melli:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.Melli]}.png`;
        break;
      case TypeIpGs.Parsian:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.Parsian]}.png`;
        break;
      case TypeIpGs.Pasargad:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.Pasargad]}.png`;
        break;
      case TypeIpGs.PayIr:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.PayIr]}.png`;
        break;
      case TypeIpGs.ZarinPal:
        path = `${this.iconsPath}${TypeIpGs[TypeIpGs.ZarinPal]}.png`;
        break;

      default:
        break;
    }

    return path;
  }

  emit(selectedItem) {
    this.selectedItem.emit(selectedItem);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
